module.exports = __webpack_public_path__ + "static/media/long-arrow-down.137f75dd.svg";